import './Modal.css';
//#region src/Modal/Modal.module.css
var Modal_module_default = {
	"content": "_1Nw9HW_content",
	"overlay": "_1Nw9HW_overlay"
};
//#endregion
export { Modal_module_default as default };

//# sourceMappingURL=Modal.module.js.map